import React from 'react'
import ReactDOM from 'react-dom/client'
import './dds-pattern-library.css'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'

const BASE_URL =
  window.location.href.indexOf('localhost') > -1
    ? '/archieml'
    : '/spContent/bespoke/my-rookie-moment/archieml'
// loads dds-pattern-library
// const loadCSS = () =>
//   new Promise((resolve) => {
//     const link = document.createElement('link')
//     link.type = 'text/css'
//     link.rel = 'stylesheet'
//     link.href =
//       'https://mckinsey.com/spContent/bespoke/mck-kids-reinforcement-learning/dds-pattern-library.css'
//     link.onload = () => {
//       resolve()
//     }
//     document.head.appendChild(link)
//   })

const loadArticleCss = () => {
  new Promise((resolve) => {
    if (window.location.href.indexOf('localhost') > -1) {
      const link = document.createElement('link')
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.href =
        'https://www.mckinsey.com/redesign/resources/css/article-148dc7.css'
      link.onload = () => {
        resolve()
      }
      document.head.appendChild(link);
    } else {
      resolve();
    }
  });
}
const loadEpisodes = async () => {
  const raw = await fetch(BASE_URL + '/episodes.json')
  const episodes = await raw.json()

  return episodes.episodes.map((x) => {
    return { ...x, sortOrder: parseInt(x.sortOrder, 10) }
  });
}

const loadContent = async (filename) => {
  return (await fetch(BASE_URL + '/' + filename)).json()
}

const main = async () => {
  const pathName = window.location.pathname

  // await loadCSS()
  await loadArticleCss();
  if (!window.appEventData) {
    window.appEventData = {
      push: (...params) => { console.log(...params) }
    };
  }
  const episodes = await loadEpisodes()

  const selectedEpisode = episodes.find(
    (x) => x.link.toLowerCase() === pathName.toLowerCase(),
  )

  const content = await loadContent(
    selectedEpisode ? selectedEpisode.file : episodes.sort((x, y) => y.sortOrder - x.sortOrder)[0].file,
  )

  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    // <React.StrictMode>
    <App
      selectedEpisode={selectedEpisode}
      episodes={episodes}
      content={content}
    />,
    // </React.StrictMode>
  )
}

main()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
